module.exports = __webpack_public_path__ + "img/JBI_PACES-product_img@2x.d45021ec.png";